import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RolePermissionService {
  private userPermissionsSource = new BehaviorSubject<Record<string, boolean>>({});
  userPermissions$ = this.userPermissionsSource.asObservable();

  constructor() {
    this.loadPermissions();

    // Listen for storage changes from other tabs/windows
    window.addEventListener('storage', this.handleStorageChange.bind(this));
  }

  private loadPermissions() {
    const storedPermissions = sessionStorage.getItem('userPermissions');
    if (storedPermissions) {
      this.userPermissionsSource.next(JSON.parse(storedPermissions)); // Notify subscribers
    } else {
    }
  }

  hasPermission(key: string): boolean {
    const hasPermission = !!this.userPermissionsSource.getValue()[key];
    return hasPermission;
  }

  updatePermissions(newPermissions: Record<string, boolean>) {
    sessionStorage.setItem('userPermissions', JSON.stringify(newPermissions));
    this.userPermissionsSource.next(newPermissions); // Manually trigger UI update
  }

  private handleStorageChange(event: StorageEvent) {
    if (event.key === 'userPermissions') {
      this.loadPermissions(); // Reload and update BehaviorSubject
    }
  }
}
